// extracted by mini-css-extract-plugin
export default {"faqItem":"faq_faqItem__7IgaL","faqQuestion":"faq_faqQuestion__JrrrT","faqAnswer":"faq_faqAnswer__Iy+3Q"};